module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO02AdministracionDelDinero.4f21b88.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO02AdministracionDelDinero.mp4
// module id = 730
// module chunks = 1